import CompetitionsList from 'src/common/components/CompetitionsList';
import { isSocialShareOgPreview } from 'src/helpers/socialShareOgLayout';
import { ICompetitionsListBlock } from 'src/interfaces/PageBlock';

export default function CompetitionsListBlockContent({
  block,
  contentKey,
}: {
  block: ICompetitionsListBlock;
  contentKey?: string;
}) {
  return (
    <CompetitionsList
      columnCount={block.columnCount ?? 4}
      ogFixedLayout={isSocialShareOgPreview(contentKey)}
    />
  );
}
